import type { ReactNode } from "react";

import { cn } from "@synthesis/shared-utils";
import { IconFileFill } from "@synthesis/shared-icons";

type DetailTabPlaceholderProps = {
  title: string;
  description?: string;
  className?: string;
  /** Иконка заглушки (по умолчанию — файл). Размер/цвет задаёт сам потребитель. */
  icon?: ReactNode;
};

export const DetailTabPlaceholder = ({
  title,
  description,
  className,
  icon = <IconFileFill className="text-neutrals-80 size-12" aria-hidden />,
}: DetailTabPlaceholderProps) => (
  <div className={cn("flex min-h-[17rem] flex-col items-center justify-center gap-3 px-6 py-10 text-center", className)}>
    {icon}
    <p className="subtitle-base text-type-common whitespace-pre-line font-medium">{title}</p>
    {description ? <p className="caption-xs text-type-minor max-w-[12.5rem]">{description}</p> : null}
  </div>
);
